import PropTypes from 'prop-types';
import React from 'react';

import FillWidthButton from '../../shared/FillWidthButton/FillWidthButton';
import styles from './MobileNewMessageButton.module.scss';

const MobileNewMessageButton = ({ transition }) => {
  return (
    <div className={styles['mobile-btn-container']}>
      <FillWidthButton onClick={() => transition('compose')}>
        New Message
      </FillWidthButton>
    </div>
  );
};

MobileNewMessageButton.propTypes = {
  transition: PropTypes.func
};

export default MobileNewMessageButton;
